import { useMediaQuery } from 'react-responsive';
import { Title } from '../../shared/title';

import { Wrapper } from '../../shared/wrapper';
import ProductItem from './product_item';

import { useTranslations } from 'next-intl';
import { FC, memo } from 'react';
import { styled } from '../../shared/styles';

let About: FC<{ className?: string }> = ({ className }) => {
  const isLeptop = useMediaQuery({ query: '(maxWidth: 1280px)' });
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const t = useTranslations();

  return (
    <div className={className}>
      <Wrapper>
        <Title id='about' textClassName='product_mw' title={t('about.title')} text={t('about.text')} />
        <div className='product_info'>
          <div className='product_top'>
            <ProductItem
              image={isLeptop ? '/images/webp/about_1t.webp' : '/images/webp/about_1t.webp'}
              title={t('about.marketing.title')}
              text={t('about.marketing.text')}
              imagePosition={{ width: isMobile ? 225 : 231 }}
            />
            <ProductItem
              imagePosition={{ height: '100%', top: 0 }}
              image={isLeptop ? '/images/webp/about_2t.webp' : '/images/webp/about_2t.webp'}
              title={t('about.investing.title')}
              text={t('about.investing.text')}
            />
          </div>
          <div className='product_bottom'>
            <ProductItem
              image={isLeptop ? '/images/webp/about_3t.webp' : '/images/webp/about_3t.webp'}
              title={t('about.gameFi.title')}
              text={t('about.gameFi.text')}
              imagePosition={{ width: 256 }}
            />
            <ProductItem
              image={isLeptop ? '/images/webp/about_4iiii.webp' : '/images/webp/about_4iiii.webp'}
              title={t('about.passiveIncome.title')}
              text={t('about.passiveIncome.text')}
              imagePosition={{ width: isMobile ? 130 : 138 }}
            />
            <ProductItem
              imagePosition={{ width: 251 }}
              className='desktop_item'
              image={isLeptop ? '/images/webp/about_5t.webp' : '/images/webp/about_5t.webp'}
              title={t('about.web3.title')}
              text={t('about.web3.text')}
            />
          </div>
          <ProductItem
            imagePosition={{ width: 251 }}
            className='leptop_item product_item'
            image={isLeptop ? '/images/webp/about_5t.webp' : '/images/webp/about_5t.webp'}
            title={t('about.web3.title')}
            text={t('about.web3.text')}
          />
        </div>
        <p className='product_text'>{t('about.description')}</p>
      </Wrapper>
    </div>
  );
};

About = styled(About, {
  '&': {
    marginTop: '120px',
    position: 'relative',
    '@to1920': {
      marginTop: '120px'
    },
    '@from2200': {
      marginTop: '120px'
    },
    '@toMedium': {
      marginTop: '120px'
    },
    '@toTablet': {
      // marginTop: '58px',
      marginTop: '80px'
    },
    '& .product_info': {
      marginTop: '44px',
      '@toXL': {
        marginTop: '42px'
      },
      '@toTablet': {
        marginTop: '38px'
      }
    }
  },
  '& .about_eclipse': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%) scale(1.24)',
    opacity: 0.8,
    width: '100vw',
    pointerEvents: 'none'
  },
  '& .product_mw': {
    maxWidth: '839px',
    '@toXL': {
      maxWidth: '631px'
    }
  },
  '& .product_item': {
    minHeight: '284px',
    '@toTablet': {
      minHeight: '254px'
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '34px 34px 28px 34px',
    width: '100%',
    height: '100%',
    borderRadius: '40px',
    overflow: 'hidden',
    // background: radial-gradient(to top right, rgba(255, 255, 255, 0.1) 10%, transparent 90%),
    background: 'linear-gradient(to top right, rgba(0, 0, 0, 0) 51%, #2a2333 100%), rgba(255, 255, 255, 0.03)',
    // radial-gradient(#e4b2fda7 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 255, 255, 0.03),
    // radial-gradient(circle, rgba(255, 255, 255, 0.1) 10%, transparent 90%),
    backdropFilter: 'blur(10px)',

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '40px',
      padding: '2px',
      background: 'linear-gradient(49deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.3))',
      '-webkit-mask': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      '-webkit-mask-composite': 'destination-out',
      'mask-composite': 'exclude',
      pointerEvents: 'none',
      zIndex: 2
    },
    '@toDesktop': {
      padding: '20px'
    },
    h3: {
      position: 'relative',
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: '34px',
      color: 'white',
      maxWidth: '290px'
    },
    p: {
      position: 'relative',
      lineHeight: '130%',
      color: '#afa5b8',
      flex: '1 1 auto',
      fontSize: '20px',
      maxWidth: '430px',
      textShadow: '0 4px 4px rgba(0, 0, 0, 1)',
      '@toXL': {
        maxWidth: '309px',
        fontSize: '18px'
      },
      '@toTablet': {
        maxWidth: 'max-content'
      }
    },
    img: {
      top: '34px',
      right: '34px',
      '@toTablet': {
        top: '24px',
        right: '20px'
      }
    }
  },
  '& .product_item_bg': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },

  '& .product_info': {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },

  '& .product_bottom': {
    gap: '22px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '1fr',
    '@toDesktop': {
      gridTemplateColumns: '1fr 1fr'
    },
    '@toTabletPortrait': {
      gridTemplateColumns: '1fr'
    },

    '@toMediumLandscape': {
      gridTemplateColumns: '1fr 1fr'
    }
  },

  '& .product_top': {
    gap: '20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    '@toDesktop': {
      gridTemplateColumns: '1fr 1fr'
    },
    '@toTabletPortrait': {
      gridTemplateColumns: '1fr'
    },

    '@toMediumLandscape': {
      gridTemplateColumns: '1fr 1fr'
    }
  },
  '& .product_additional': {
    position: 'absolute'
  },
  '& .desktop_item': {
    display: 'flex',
    '@toDesktop': {
      display: 'none'
    }
  },
  '& .leptop_item': {
    display: 'none',
    '@toDesktop': {
      display: 'flex'
    }
  },
  '& .product_text': {
    textAlign: 'center',
    fontSize: '28px',
    background: 'linear-gradient(135deg, #94a8e2 10%, #c430d4 100%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    maxWidth: '822px',
    margin: '0 auto',
    marginTop: '38px',
    fontWeight: 300,
    lineHeight: '140%',
    fontFamily: 'Unbounded',
    '@toDesktop': {
      marginTop: '34px'
    },
    '@toTablet': {
      fontSize: '20px',
      lineHeight: 'normal',
      marginTop: '36px'
    }
  }
});

export default memo(About);
